package org.vreo.devicehub.features.userAuthentication.data.dto

import kotlinx.serialization.Serializable

/**
 * User details DTO, used for signup and user's details management
 */
@Serializable
data class UserDetailsDto(
    // Main credentials
    val email: String,
    val password: String,
    val firstName: String,
    val lastName: String,
    val mobileNumber: String? = null,

    // Account management
    val role: Int? = null,

    // Company info
    val companyName: String? = null,
    val companyAddressStreet: String? = null,
    val companyAddressCity: String? = null,
    val companyAddressPostalCode: String? = null,
    val companyAddressCountry: String? = null,
)